/* eslint-disable max-len */
import { api, ApiAction, IApiOptions } from '../../utils/api/actions';
import { CustomAction } from '../../utils/types';
import { Constants } from './constants';

export type SetPlayers = ApiAction<typeof Constants.SET_PLAYER, void>;
export type SetSideOne = CustomAction<typeof Constants.SET_SIDE_ONE, boolean>;
export type SetSideTwo = CustomAction<typeof Constants.SET_SIDE_TWO, boolean>;

export const setPlayers = (sport: string, site: string, token: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = `/api/playercompare/players`;

  options = {
    ...options,
    route,
    params: {
      sport,
      site,
      token
    },
  };

  return api(
    Constants.SET_PLAYER, {
    ...options,
  },
  );
};

export const setSideOne = (players: string[]) => ({
  type: Constants.SET_SIDE_ONE,
  payload: players,
});

export const setSideTwo = (players: string[]) => ({
  type: Constants.SET_SIDE_TWO,
  payload: players,
});


export const setResults = (sport: string, site: string, token: string, ids1: string[], ids2: string[]) => {
  let options: IApiOptions = {
    method: 'POST',
    route: '',
  };

  const route = '/api/playercompare/compare';
  


  options = {
    ...options,
    route,
    params: {
      sport,
      site,
      token
    },
    data: {
      ids1,
      ids2,
    }
  };

  return api(
    Constants.SET_RESULTS, {
    ...options,
  },
  );
};

export const setFfOptions = (sport: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  }

  const route = `/api/playercompare/scoringconfig`;

  options = {
    ...options,
    route,
    params: {
      sport,
    },
  };

  return api(
    Constants.SET_FF_OPTIONS, {
    ...options,
  },
  );
}

export const setScoring = (scoring: string) => ({
  type: Constants.SET_SCORING,
  payload: scoring,
})

export const setAuth = (sport: string, token: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/auth';

  options = {
    ...options,
    route,
    params: {
      sport,
      token,
      appName: 'startsit',
    },
  };

  return api(
    Constants.SET_AUTH, {
    ...options,
  },
  );
};